// extracted by mini-css-extract-plugin
export default {"dark":"Sidebar_dark__3FlBF","light":"Sidebar_light__0OcIj","common_sidebar":"Sidebar_common_sidebar__BfEO5"};